export default{
    langzh: '简体中文',
    langen: '英文',
    i18n: '简体中文',
    today: "今天",
    yesterday: "昨天",
    tomorrow: "明天",
    last7Days: "近七天",
    nearly1month: "近一月",
    nearly3months: "近三月",
    next7Days: "之后七天",
    nextMonth: "之后一月",
    next3Months: "之后三月",
    year: "年",
    month: "月",
    day: "日",
}